import './style/index.less';
import ImportUploadPanel from './ImportUploadPanel';

export default ImportUploadPanel;
